import { PayloadAction, createSlice } from '@reduxjs/toolkit';
export type DataState = {
  countries: any;
  timezones: any;
};

const initialState: DataState = {
  countries: [],
  timezones: []
};

export const DictionariesSlice = createSlice({
  name: 'dictionaries',
  initialState,
  reducers: {
    loadCountries(state, action: PayloadAction<any>) {
      state.countries = action.payload;
    },
    loadTimezones(state, action: PayloadAction<any>) {
      state.timezones = action.payload;
    },
  },
});

export default DictionariesSlice.reducer;
